<script setup lang="ts">
import { computed } from 'vue'
import { distance } from '../services/format'
import DsIcon from './DsIcon.vue'
import VenueHero from './VenueHero.vue'

const props = defineProps<{ venue: any; compact?: boolean }>()
const id = computed(() => String(props.venue?.id || ''))
const name = computed(() => String(props.venue?.displayName || props.venue?.name || '未命名场馆'))
const tags = computed(() => {
  const raw = props.venue?.tags || props.venue?.courtTags || props.venue?.facilities || []
  return (Array.isArray(raw) ? raw : []).map((item: any) => String(item?.label || item?.name || item)).filter(Boolean).slice(0, 3)
})
const price = computed(() => {
  if (props.venue?.priceFrom != null) return Number(props.venue.priceFrom)
  const cents = props.venue?.priceFromCents ?? props.venue?.minPriceCents ?? props.venue?.pricePerHourCents
  return cents == null ? null : Number(cents) / 100
})
</script>

<template>
  <RouterLink class="venue-card" :class="{ compact }" :to="{ path:`/venues/${encodeURIComponent(id)}`, query: venue.distanceMeters != null ? { distanceMeters: venue.distanceMeters } : undefined }">
    <VenueHero :name="name" :image="venue.images?.[0]" :images="venue.images" :tone-key="id" :province="venue.province" :city="venue.city" :district="venue.district" compact />
    <div class="venue-content">
      <div class="card-title-row">
        <h3>{{ name }}</h3>
        <DsIcon v-if="venue.isFavorite || venue.star" class="filled-icon" name="bookmark" :size="18" fill />
      </div>
      <p class="muted-line"><DsIcon name="place" :size="15" />{{ venue.address || venue.addr || '地址待完善' }}<span v-if="distance(venue.distanceMeters)">· {{ distance(venue.distanceMeters) }}</span></p>
      <div class="tag-row"><span v-for="tag in tags" :key="tag" class="chip chip-muted">{{ tag }}</span></div>
      <div class="card-footer"><strong v-if="price != null">¥{{ price }}<small>/小时起</small></strong><span>{{ venue.inventoryText || venue.bookingStatusText || '查看详情' }}</span></div>
    </div>
  </RouterLink>
</template>
